"use client"

import { useEffect, useState } from 'react'
import { Search } from 'lucide-react'

export default function BlogSearchTriggerClient() {
  const [active, setActive] = useState(false)

  useEffect(() => {
    function onState(event: Event) {
      const detail = (event as CustomEvent<{ active?: boolean }>).detail
      setActive(Boolean(detail?.active))
    }
    window.addEventListener('blog-search-state', onState as EventListener)
    return () => window.removeEventListener('blog-search-state', onState as EventListener)
  }, [])

  return (
    <button
      data-blog-search-trigger
      type="button"
      onClick={() => window.dispatchEvent(new Event('open-blog-search'))}
      className={`inline-flex h-8 w-8 items-center justify-center rounded border ${active ? 'bg-black text-white border-black' : 'hover:bg-gray-50'}`}
      aria-label="Open blog search"
      aria-pressed={active}
    >
      <Search size={16} />
    </button>
  )
}
